"use client";
import { Button, message as messageToast } from "antd";
import { ManageCookie } from "./ManageCookie";
import { useEffect, useState } from "react";
import { cookieRecord } from "@/service/user";
import { CookieType } from "@/service/user/enum";
import { Storage } from "@/utils/storage";
import useMobileDetect from "@/hooks/useMobileDetect";
import { openPricacyPolicy } from "@/utils/tools";
import { PrivacyPolicyPagesEnum } from "@/utils/const";

export type BottomCookieProps = {
  container?: string;
};

export const BottomCookie: React.FC<BottomCookieProps> = ({ ...props }) => {
  const [open, setOpen] = useState(false);
  const [cookie, setCookie] = useState(true);
  const isMobile = useMobileDetect();

  useEffect(() => {
    const value = !!Storage.getItem("cookie-consent");
    setCookie(value);

    if (!value) {
      document.body.style.paddingBottom = isMobile ? "302px" : "140px";
    }
  }, [isMobile]);

  const handleCookie = async (value: string[]) => {
    const { status, message } = await cookieRecord(
      localStorage.getItem("deviceId") ?? "",
      { accepted: value },
    );

    if (status === 200) {
      setCookie(true);
      document.body.style.paddingBottom = "0px";
      Storage.setItem("cookie-consent", { accepted: value });
    } else {
      messageToast.error(message);
    }
  };

  return (
    <>
      {!cookie && (
        <div className="leading-26 fixed bottom-0 left-0 z-50 w-full bg-bravve-bg-100 px-16 pb-24 pt-22 lg:px-40 lg:py-21">
          <div
            className={
              props?.container ??
              "flex w-full flex-wrap justify-between md:flex-nowrap"
            }
          >
            <div>
              <div className="text-xl font-medium text-bravve-100">
                We value your privacy
              </div>
              <div className="mt-14 leading-22 text-bravve-sub-100">
                We use cookies and other technologies to personalize your
                experience, perform marketingand collect analytics. Learn more
                in our{" "}
                <span
                  className="cursor-pointer border-b border-solid border-bravve-sub-100"
                  onClick={() =>
                    openPricacyPolicy(PrivacyPolicyPagesEnum.PrivacyPolicy)
                  }
                >
                  Privacy Policy.
                </span>
              </div>
              <div className="text-bravve-sub-100">
                Click here to{" "}
                <span
                  className="border-b border-b-bravve-100 text-bravve-100 hover:cursor-pointer"
                  onClick={() => {
                    setOpen(true);
                  }}
                >
                  Manage Preferences.
                </span>
              </div>
            </div>

            <div className="mt-28 flex w-full flex-col justify-center md:mt-0 md:w-240">
              <Button
                size="small"
                onClick={async () => {
                  handleCookie([]);
                }}
              >
                Reject all
              </Button>
              <Button
                type="primary"
                className="mt-14"
                size="small"
                onClick={() => {
                  handleCookie([
                    CookieType.Required,
                    CookieType.Personalization,
                    CookieType.Marketing,
                    CookieType.Analytics,
                  ]);
                }}
              >
                Accept all
              </Button>
            </div>
            <ManageCookie
              open={open}
              onClose={() => {
                setOpen(false);
              }}
              onManageCookie={() => {
                setCookie(true);
              }}
            />
          </div>
        </div>
      )}
    </>
  );
};
